<template>
  <v-dialog scrollable class="dialog" v-model="config.status.active" width="600">
    <v-card>
      <v-card-title class="secondary white--text headline">登録請求一覧</v-card-title>
      <v-card-text>
        <v-progress-linear class="ma-0" v-if="isLoading" indeterminate color="blue"></v-progress-linear>
        <v-window v-else v-model="config.page">
          <v-window-item value="main">
            <MainPane :items="getItems" @open="openDetail" />
          </v-window-item>
          <v-window-item value="detail">
            <DetailPane :item="getSelectedItem" />
          </v-window-item>
        </v-window>
      </v-card-text>
      <v-card-actions>
        <v-btn text v-if="config.page === 'main'"
          color="secondary"
          @click="close">閉じる</v-btn>
        <v-btn text v-if="config.page === 'detail'"
          color="secondary"
          @click="closeDetail">戻る</v-btn>
        <v-spacer></v-spacer>
        <v-btn depressed v-if="config.page === 'detail'"
          color="secondary"
          @click.stop="submit({ type: 'remove' })">削除する</v-btn>
      </v-card-actions>
      <ConfirmModal ref="confirmer" />
    </v-card>
  </v-dialog>
</template>

<script>
import MainPane from './panes/main'
import DetailPane from './panes/detail'
import ConfirmModal from '@/components/modals/confirm'
const DEF = {
  PAGE: 'main'
}
export default {
  name: 'ListModal',
  props: [ 'item' ],
  components: {
    MainPane,
    DetailPane,
    ConfirmModal
  },
  data () {
    return {
      config: {
        status: {
          loading: false,
          active: false
        },
        page: DEF.PAGE
      },
      store: {
        items: [],
        item: null
      }
    }
  },
  methods: {
    get: function () {
      if (this.$props.item && this.$props.item.id) {
        this.$set(this.config.status, 'loading', true)
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(`${this.$url.api}cbook/get/bills/${this.$props.item.id}`, {}, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            this.$set(this.config.status, 'loading', false)
            if (res.data && res.data.success) {
              this.$set(this.store, 'items', res.data.data)
            }
          }).catch(err => {
            console.log(err)
            this.$set(this.config.status, 'loading', false)
          })
        }).catch(err => {
          console.log(err)
          this.$set(this.config.status, 'loading', false)
        })
      }
    },
    open: function () {
      this.$set(this.config, 'page', DEF.PAGE)
      this.$set(this.config.status, 'active', true)
      this.get()
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    },
    submit: function (req) {
      const urls = {
        remove: `${this.$url.api}cbook/remove/bill`
      }
      const url = (req && req.type && urls[req.type]) ? urls[req.type] : ''
      if (url) {
        this.$refs.confirmer.open({
          message: 'この請求書を削除してもよろしいですか？',
          callback: () => {
            this.$set(this.config.status, 'loading', true)
            this.$firebase.auth().currentUser.getIdToken(true).then(token => {
              this.axios.post(url, {
                uid: this.store.item.id
              }, {
                headers: {
                  'firebase-token': token
                }
              }).then(res => {
                console.log(res)
                if (res.data && res.data.success) {
                  this.$emit('done')
                  this.close()
                }
                this.$set(this.config.status, 'loading', false)
              }).catch(err => {
                console.log(err)
                this.$set(this.config.status, 'loading', false)
              })
            })
          }
        })
      }
    },
    openDetail: function (id) {
      let idx = this.store.items.findIndex(it => { return it.id === id })
      if (idx >= 0) {
        this.$set(this.store, 'item', this.store.items[idx])
        this.$set(this.config, 'page', 'detail')
      }
    },
    closeDetail: function () {
      this.$set(this.config, 'page', 'main')
    }
  },
  computed: {
    isLoading () {
      return this.config.status.loading
    },
    isActive () {
      return this.config.status.active
    },
    getItems () {
      return this.store.items.length ? this.store.items : []
    },
    getSelectedItem () {
      return this.store.item
    }
  }
}
</script>
